angular.module("ainapp")
    .controller("bulkFundPaymentController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            //            $scope.PageName = "Bulk Delivery Note";
            //            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            //            if ($scope.TokenInfo == null) {
            //                $state.go("login");
            //            } else {
            //                $scope.checkUserPageAccess($scope.PageName);
            //            }

            $scope.Init = function () {

                $scope.VoucherList = [];


            }
            $scope.Init();


            var oFileIn;

            $(function () {
                oFileIn = document.getElementById('my_file_input');
                if (oFileIn.addEventListener) {
                    oFileIn.addEventListener('change', filePicked, false);
                }
            });

            function filePicked(oEvent) {
                var oFile = oEvent.target.files[0];
                var sFilename = oFile.name;
                var reader = new FileReader();

                reader.onload = function (e) {
                    var data = e.target.result;
                    var cfb = XLSX.read(data, {
                        type: 'binary'
                    });
                    console.log(cfb)
                    $scope.VoucherList = [];

                    cfb.SheetNames.forEach(function (sheetName) {
                        var sCSV = XLS.utils.make_csv(cfb.Sheets[sheetName]);
                        var oJS = XLS.utils.sheet_to_json(cfb.Sheets[sheetName]);
                        //.replace(/-/g, "/");
                        angular.forEach(oJS, function (e) {

                            var voucher = {
                                DateString: e.Date,
                                VoucherNumber: e.VoucherNumber,
                                Amount: parseFloat(e.Amount),
                                Remarks: e.Remarks,
                                Field1: e.Field1,
                                DebitAccountName: e.DebitAccountName,
                                CreditAccountName: e.CreditAccountName,
                            }

                            $scope.VoucherList.push(voucher);
                        });


                        $scope.$apply();
                    });
                };

                reader.readAsBinaryString(oFile);
            }



            $scope.uploadProducts = function () {

                var temp = "";
                angular.forEach($scope.VoucherList, function (e) {

                    if (e.DateString == null || e.DateString == "" || e.DateString == undefined) {
                        temp = "Date Invalid";
                    } else if (e.DebitAccountName == null || e.DebitAccountName == "" || e.DebitAccountName == undefined || e.DebitAccountName == null ||
                        e.DebitAccountName == "" || e.DebitAccountName == undefined) {
                        temp = "Debit Account Invalid";
                    } else if (e.VoucherNumber == null || e.VoucherNumber == "" || e.VoucherNumber == undefined) {
                        temp = "Voucher No Invalid";
                    } else if (e.CreditAccountName == null || e.CreditAccountName == "" || e.CreditAccountName == undefined) {
                        temp = "Credit Account Invalid";
                    } else if (!e.Amount > 0) {
                        temp = "Amount Invalid";
                    }
                })

                if (temp == 1) {
                    toastr.warning(temp);
                } else {

                    var salesinvs = [];

                    angular.forEach($scope.VoucherList, function (e) {

                        var olddata = null;
                        angular.forEach(salesinvs, function (ee) {
                            if (ee.VoucherNumber == e.VoucherNumber) {
                                olddata = ee;
                            }
                        })

                        if (olddata == null) {
                            var sales = {
                                DateString: e.DateString,
                                VoucherNumber: e.VoucherNumber,
                                Field1: e.Field1,
                                Total: e.Total,
                                Remarks: e.Remarks,
                                CreditAccountName: e.CreditAccountName,
                                FPVUploadDetails: [],
                            }
                            var det = {
                                Amount: e.Amount,
                                Remarks: e.Remarks,
                                DebitAccountName: e.DebitAccountName,
                            }
                            sales.FPVUploadDetails.push(det);
                            salesinvs.push(sales);
                        } else {
                            var det = {
                                Amount: e.Amount,
                                Remarks: e.Remarks,
                                DebitAccountName: e.DebitAccountName,
                            }
                            olddata.FPVUploadDetails.push(det);
                        }

                    })

                    console.log(salesinvs);

                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.UploadFPVMaster(salesinvs).then(function (response) {
                        if (response.data == "Success") {
                            toastr.success("Success");
                            $scope.Init();
                        } else {
                            toastr.warning(response.data);
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }


            }



        }])
